import * as React from 'react';

import { use$ } from '@legendapp/state/react';
import {
	Breakpoints,
	CTA,
	Text,
	TextAlignment,
	TokenTextAppearance,
	WhiteSpace
} from '@volkswagen-onehub/components-core';
import styled from 'styled-components';

import translate from '../../utils/translate';

import { ContentId, ProductView, TRACKING_TIMER, TrackingEventName } from '../../store/stores/tracking/types';

import { fullscreenStore, interiorStore } from '../../store';
import { trackingStore } from '../../store/stores/tracking-store';
import { testId } from '../../test-utils/constants';

export const ExitInteriorButton = () => {
	const isFullscreenMode = use$(fullscreenStore.isFullscreenMode);
	const isInteriorMode = use$(interiorStore.isInteriorLoaded);

	if (!isInteriorMode) return null;

	return (
		<ExitInteriorButtonWrapper $isFullscreenMode={isFullscreenMode}>
			<StyledExitInteriorButton
				data-testid={testId('Interior_Exit_Button')}
				tag="button"
				aria-label={translate('global.ariaLabel.back')}
				emphasis="secondary"
				size="small"
				onClick={() => {
					interiorStore.isInteriorLoaded.set(false);
					trackingStore.setTrackingTimer(
						TRACKING_TIMER.PRODUCTVIEW_INTERIOR_NAME,
						TrackingEventName.VISUALIZER_MENU_CLICK,
						{
							contentId: ContentId.MENU,
							sectionName: ProductView.INTERIOR_VIEW
						}
					);
				}}
			>
				<ExitInteriorLabel
					staticSize
					whiteSpace={WhiteSpace.pre}
					appearance={TokenTextAppearance.copy200}
					textAlign={TextAlignment.center}
				>
					{translate('global.ariaLabel.exitInterior')}
				</ExitInteriorLabel>
			</StyledExitInteriorButton>
		</ExitInteriorButtonWrapper>
	);
};

const StyledExitInteriorButton = styled(CTA)`
	${({ theme }) =>
		theme.variant === 'v26' &&
		`
			&& {				
				border-radius: 4px;
				border: 1px solid #D9CDBD;
				background-color: transparent;
				box-shadow: none;
			}

			&&:hover {
				background-color: rgba(255, 255, 255, 0.06);
			}

			&&:focus-visible {
				outline: none;
				box-shadow: inset 0 0 0 1px #44547a;
			}
		`}
`;

const ExitInteriorLabel = styled(Text)`
	${({ theme }) =>
		theme.variant === 'v26' &&
		`
			&& {
				color: #D0D1D5;
				font-weight: 400;
				font-size: 14px;
				line-height: 150%;
			}
		`}
`;

const ExitInteriorButtonWrapper = styled.div<{ $isFullscreenMode: boolean }>`
	// If padding removed, remove same in 'slider' component
	padding-top: ${({ theme }) => theme.size.static150};

	// Bottom is set here for control panel as we require the padding for a11y outline
	padding-bottom: ${({ theme }) => theme.size.static150};
	margin: 0 ${({ theme }) => theme.size.static250};

	// Similar styling as in options-selection, opposite side for fullscreen
	display: flex;
	justify-content: start;

	@media (min-width: ${Breakpoints.b960}px) {
		justify-content: center;
		${({ $isFullscreenMode }) => $isFullscreenMode && 'justify-content: start;'}
	}

	${({ theme }) =>
		theme.variant === 'v26' &&
		`
			width: 100%;
		`}
`;
